import api from '../../services/api';

export interface MailingPayload {
  email: string;
  tipo: string;
  id: string;
}

async function confirmMailing(data: MailingPayload) {
  const response = await api<null>('POST', 'mailing/register', data);

  return response;
}

const mailingAPI = {
  confirmMailing,
};

export default mailingAPI;
